import PropTypes from 'prop-types'

import { TextMessageCommunicatorType } from '../../models/message/text-message-communicator-type-enum'
import { idPropType } from '../common/id-prop-type'

/**
 * A general communicator that can currently be a driver or a dispatcher. Can represent a sender or receiver of a text message.
 *
 * @typedef {Object} TextMessageCommunicator
 *
 * @property {TextMessageCommunicatorType} type
 * @property {Id} [driverId]  - The identifier of the driver. Can be empty if the driver assignment feature is not used
 *                              and we don’t have a driver representation in WEBFLEET.
 * @property {Id} [objectId]  - The identifier of the object the message was sent to or is sent from.
 * @property {Id} [userId]    - The userId of the dispatcher or fleet manager that is sending or receiving a text message.
 */
export const textMessageCommunicatorPropType = PropTypes.shape({
    driverId: idPropType,
    objectId: idPropType,
    type: PropTypes.oneOf(Object.values(TextMessageCommunicatorType)).isRequired,
    userId: idPropType
})
